import React from "react"
import Image from "gatsby-image"
import styled from "styled-components"

const ImageWithText = (props) => {
    return (
        <Container {...props}>
            {props.isSquare ?
                <Img fluid={{ ...props.src, aspectRatio: 1 / 1 }} src={props.src} {...props} />
                :
                <Img fluid={props.src} src={props.src} />
            }
            <InnerText>{props.children}</InnerText>
        </Container>
    )
}
const Img = styled(Image)`

opacity: ${props => props.opacity || '50%'};
transition: opacity 0.5s;
&:hover{
    opacity: 100%;
}

`
const Container = styled.div`
position: relative;
background-color: ${props => props.background || 'black'};
color: ${props => props.color || 'white'};
text-align: center;
max-height: ${props => props.maxHeight || '300px'};
`

const InnerText = styled.div`
position: absolute;
top: 50%;
left: 50%;
text-shadow: 1px 0px 4px rgba(0,0,0,0.95);
pointer-events: none;
transform: translate(-50%, -50%);
* {
    margin-bottom: 0!important;
}
backdrop-filter: blur(3px) brightness(80%) opacity(80%);

`

export default ImageWithText